import axios from 'axios';
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 50000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');

        if (!config.url.includes('/api/Ttstospeeh/synthesize')) {
            
            if (token) {
                config.headers['token'] = token;
            }
        }
        
        
        // 只有当没有设置Content-Type时才设置默认值，避免覆盖文件上传的multipart/form-data
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json; charset=utf-8';
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    
    response => {
        
        // 对于文件下载类型的响应，返回完整的响应对象以保留headers
        // 其他常规JSON响应返回data部分
        const contentType = response.headers['content-type'];
        if (contentType && (contentType.includes('blob') || contentType.includes('octet-stream') || contentType.includes('xlsx'))) {
            return response; // 返回完整响应，包含headers
        }
        // 处理常规JSON响应数据
        const res = response.data;
        return res;
        
    },
    error => {
        // 处理响应错误
        if(error.response.status === 401){
            const redirectUrl = window.location.pathname + window.location.search;
            router.push({
                name: 'Login',
                query: {
                    redirect: encodeURIComponent(redirectUrl)
                }
            })
        }
    }
);

export default service;